import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import CereJ from './pages/CereJ';
import CentroConvivencia from './pages/CentroConvivencia';
import DoceVenttura from './pages/DoceVenttura';
import Quadronizei from './pages/Quadronizei';
import BirutaHamburgueria from './pages/BirutaHamburgueria';
import EditoraIluminada from './pages/EditoraIluminada';
import Endbar from './components/Endbar';

function App() {
  return (
    <Router>
      <div>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cerej" element={<CereJ />} />
          <Route path="/centro-de-convivencia" element={<CentroConvivencia />} />
          <Route path="/doce-venttura" element={<DoceVenttura />} />
          <Route path="/quadronizei" element={<Quadronizei />} />
          <Route path="/biruta-hamburgueria" element={<BirutaHamburgueria />} />
          <Route path="/editora-iluminada" element={<EditoraIluminada />} />
        </Routes>
        <Endbar />
      </div>
    </Router>
  );
}

export default App;
